import { render } from "./confidentiality and data protection policy.vue?vue&type=template&id=4a60a7bb&scoped=true"
const script = {}

import "./confidentiality and data protection policy.vue?vue&type=style&index=0&id=4a60a7bb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a60a7bb"]])

export default __exports__